<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <Modal
    id="modalValidationBird"
    id-name="modalValidationBird"
    @keydown.enter="authUser"
  >
    <template #modal-header="">
      <button
        id="btnCloseModal"
        class="btn-close"
        type="button"
        data-bs-dismiss="modal"
        aria-label="Close"
        @click="handleModalClose"
      ></button>
    </template>
    <template #modal-body="">
      <h2 v-if="!isOtpPreFilled">
        Abra seu aplicativo Bird ID no seu celular e digite abaixo CPF e o
        código OTP do solicitante para prosseguir com a emissão.
      </h2>
      <h2 v-else>Confirme seu CPF</h2>
      <InputComponent
        v-model="model.cpf"
        label="CPF"
        icon="address-card"
        :mask="['###.###.###-##', '']"
        :error-log="errors.cpf"
        placeholder="Digite apenas números"
        :is-numeric="true"
      />
      <InputComponent
        v-show="!isOtpPreFilled"
        v-model="model.otp"
        :mask="['### ###', '']"
        icon="key"
        label="OTP (Bird ID)"
        :error-log="errors.otp"
        autocomplete="off"
        placeholder="Digite apenas números"
        :is-numeric="true"
        :is-disabled="isOtpPreFilled"
      />
      <div v-if="!isOtpPreFilled" id="faqAccordion" class="accordion">
        <div class="accordion-item">
          <div id="faqAccordionQuestionOne" class="accordion-header">
            <button
              class="btn accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faqAccordionAnswerOne"
              aria-expanded="false"
              aria-controls="faqAccordionAnswerOne"
            >
              Onde encontro o OTP?
            </button>
          </div>
          <div
            id="faqAccordionAnswerOne"
            class="accordion-collapse collapse"
            aria-labelledby="faqAccordionQuestionOne"
            data-bs-parent="#faqAccordion"
          >
            <div class="accordion-body text-start">
              <p class="m-0">
                Para gerar o código OTP, basta acessar o aplicativo BirdID no
                seu celular, fazer o login e digitar o número que aparece na sua
                tela inicial.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="form-check text-start">
          <input
            id="default-checkbox"
            v-model="model.termos"
            class="form-check-input form-check-input--success"
            type="checkbox"
          />
          <span class="form-check-label me-1" for="default-checkbox">
            Li e concordo com a
          </span>
          <a
            class="link-info text-decoration-underline"
            href="/PoliticadePrivacidade.pdf"
            target="_blank"
            >política de privacidade
          </a>
        </div>
      </div>
    </template>
    <template #modal-footer="">
      <button
        class="btn"
        :class="!isValid ? 'btn-secondary' : 'btn-primary'"
        type="button"
        :disabled="!isValid"
        @click="authUser"
      >
        <span class="me-2">Avançar</span>
        <Icon v-if="!loading" name="arrow-right"></Icon>
        <div
          v-else
          class="spinner-border"
          style="width: 1rem; height: 1rem"
          role="status"
        ></div>
      </button>
    </template>
  </Modal>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Modal from '@/components/Molecules/Modal.vue'
  import InputComponent from '@/components/Atoms/Input.vue'
  import loginController, {
    VoucherParam,
  } from '@/infra/BirdId/controllers/login.controller'
  import allValidates from '@/utils/validates'
  import { AxiosError } from 'axios'
  import { mapActions, mapState } from 'pinia'
  import { useMainStore } from '@/store/Pinia/useMain.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import saveDataVoucher from '@/utils/saveDataVoucher'
  import gvsController from '@/infra/sisAr/gvs.controller'
  import { GVSStatusEnum } from '@/types/enums/EGVS.enum'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'

  import config from '../../../config'

  export default defineComponent({
    components: {
      Icon,
      Modal,
      InputComponent,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      isMobile: false,
      showCookiesAlert: true,
      isOtpPreFilled: false,
      model: {
        cpf: '',
        otp: '',
        termos: false,
      },
      errors: {
        cpf: '',
        otp: '',
        ar: '',
      },
      loading: false,
    }),
    watch: {
      'model.cpf': function watch(curr: string) {
        if (this.isHubAutoAuth) {
          this.errors.cpf = ''
          return
        }
        if (curr.length === 14 && !allValidates.validateCPF(curr)) {
          this.errors.cpf = 'CPF inválido!'
        } else {
          this.errors.cpf = ''
        }
      },
      'model.otp': function watch(curr: string) {
        if (curr.length > 0) {
          this.errors.otp = ''
        }
      },
    },
    computed: {
      ...mapState(useDynamicForms, ['getFormData']),
      ...mapState(useMainStore, [
        'cookies',
        'unidade',
        'getValidBirdSessionToken',
        'hubCpfCnpj',
      ]),
      ...mapState(useSolicitation, ['getProduto']),
      ...mapState(useAR, ['arData']),
      isHubAutoAuth() {
        return this.isOtpPreFilled && !!this.hubCpfCnpj
      },
      isValid() {
        const otpClean = this.model.otp.replace(/\D/g, '')

        return (
          // eslint-disable-next-line operator-linebreak
          this.model.cpf &&
          // eslint-disable-next-line operator-linebreak
          otpClean.length === 6 &&
          // eslint-disable-next-line operator-linebreak
          this.model.termos &&
          // eslint-disable-next-line operator-linebreak
          this.errors.cpf === '' &&
          this.errors.otp === ''
        )
      },
    },
    mounted() {
      const modalElement = document.getElementById('modalValidationBird')
      if (modalElement) {
        modalElement.addEventListener('show.bs.modal', this.handleModalShown)
      }
    },
    beforeUnmount() {
      const modalElement = document.getElementById('modalValidationBird')
      if (modalElement) {
        modalElement.removeEventListener('show.bs.modal', this.handleModalShown)
      }
    },
    methods: {
      ...mapActions(useRouteBirdId, ['setRouterDone']),
      ...mapActions(useDynamicForms, ['setCPF', 'setFormData']),
      ...mapActions(useMainStore, [
        'setUnidade',
        'setBirdSessionToken',
        'clearBirdSessionToken',
      ]),
      ...mapActions(useSolicitation, ['setCessToken', 'setIsRFB']),
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      handleModalShown(event: Event) {
        this.isOtpPreFilled = false

        if (this.getValidBirdSessionToken) {
          this.isOtpPreFilled = true
        }

        this.model.otp = this.getValidBirdSessionToken

        if (this.hubCpfCnpj) {
          event.preventDefault()
          this.model.cpf = this.hubCpfCnpj
          this.model.termos = true
          this.setIsLoading({
            isLoading: true,
            title: 'Autenticando...',
            image: 'clock',
          })
          void this.authUser().finally(() => {
            this.setIsLoading({ isLoading: false })
          })
        }
      },
      handleModalClose() {
        this.oeRecaptcha.hideBadge()
        this.isOtpPreFilled = false
        this.model.otp = ''
        this.model.cpf = ''
        this.errors.otp = ''
      },
      async authUser() {
        if (this.isOtpPreFilled) {
          const currentValidToken = this.getValidBirdSessionToken

          if (!currentValidToken) {
            this.isOtpPreFilled = false
            this.model.otp = ''
            this.errors.otp =
              'Sessão expirada. Volte a página inicial e recomece o processo.'
            return
          }
        }

        if (this.isHubAutoAuth || (!this.errors.cpf && !this.errors.otp)) {
          const requestLogin = {
            username: this.model.cpf,
            otp: this.model.otp,
            recaptcha_token: '',
          }
          try {
            this.loading = true

            const recaptchaToken = await this.oeRecaptcha.getToken('justauth')

            Object.assign(requestLogin, {
              recaptcha_token: recaptchaToken,
            })

            const { data } = await loginController.login(requestLogin)

            const formatted = {
              token: {
                sessionData: data.sessionData,
                sessionId: data.sessionId,
              },
              nome: data.nome,
            }
            this.saveData(formatted)

            if (this.getProduto.token !== '') {
              if (!config.app.negociations.includes(this.getProduto.token)) {
                this.toggleToastGlobal({
                  isShow: true,
                  message: GVSStatusEnum.NEGOTIATION_NOT_FOUND.mensagem,
                })
                // eslint-disable-next-line no-throw-literal
                throw 'Não existe a negociação para a AR'
              }

              const response = await this.getVoucherBirdId()

              if (response.status !== GVSStatusEnum.VOUCHER_SUCCESS.status) {
                // eslint-disable-next-line max-len, @typescript-eslint/no-unused-vars
                const ArrayEnum = Object.entries(GVSStatusEnum).map(
                  ([_, value]) => value,
                )
                const findedEnum = ArrayEnum.find(
                  (x) => x.status === response.status,
                )
                this.toggleToastGlobal({
                  type: 'danger',
                  isShow: true,
                  message:
                    findedEnum?.mensagem || 'Erro ao buscar sua negociação',
                })
                throw response.voucher
              }

              const request: VoucherParam = {
                token: formatted.token,
                arsubdomain: this.arData.subdomain || '',
                voucher: response.voucher || '',
                produtos: [this.getProduto],
              }

              if (this.unidade) {
                request.unidade = this.unidade
              }

              const { data: loginResponse } =
                await loginController.validateVoucher(request)

              this.setIsRFB(loginResponse.isRFB)

              const payload = {
                ...loginResponse,
                voucher: response.voucher || '',
              }

              saveDataVoucher(payload)
              this.setRouterDone('voucher')
              this.$router.push('/birdId/form')
              this.closeModal()
              return
            }
            this.closeModal()
            this.$router.push('/birdId/voucher')
            return
          } catch (error) {
            if (this.isHubAutoAuth) {
              if (typeof error !== 'string') {
                const axiosError = error as AxiosError
                this.toggleToastGlobal({
                  isShow: true,
                  type: 'danger',
                  message: `Erro ao autenticar com o Hub. ${
                    (axiosError.response?.data as { message?: string })
                      ?.message ||
                    axiosError.message ||
                    'Tente novamente.'
                  }`,
                })
              }
              this.clearBirdSessionToken()
            } else {
              const err = error as AxiosError
              if (err) {
                this.errors.otp = 'Credenciais inválidas!'
              }
            }
          } finally {
            this.loading = false
          }
        }
      },
      saveData(data: {
        token: {
          sessionId: string
          sessionData: string
        }
        nome: string
      }) {
        this.setCessToken(data.token)
        this.setCPF(this.model.cpf)
        this.setFormData({
          ...this.getFormData,
          cpf: this.model.cpf,
          nome: data.nome,
        })
      },
      async getVoucherBirdId() {
        const voucherBirdId = await gvsController.generateVoucher(
          this.getFormData.nome,
          this.model.cpf,
          this.getProduto.token,
        )

        return voucherBirdId
      },
      closeModal() {
        this.oeRecaptcha.hideBadge()
        const overlay = document.getElementsByClassName('modal-backdrop')
        const modal = document.getElementById('modalValidationBird')
        ;[...overlay].forEach((element) => {
          element.remove()
        })
        if (modal) {
          modal.classList.remove('show')
        }
      },
    },
  })
</script>
